/** Canonical hosted app (same origin as Supabase Site URL). */
export const APP_ORIGIN = "https://jobily.squareoneinternational.com";

/** Full dashboard in a browser tab (hash router). */
export const WEBVIEW_URL = `${APP_ORIGIN}/#/webview`;

/** Email confirmation link target on the hosted site. */
export const ACCOUNT_CONFIRMATION_URL = `${APP_ORIGIN}/#/account-confirmation`;

/** Password reset link target (Supabase redirectTo / email flow). */
export const RESET_PASSWORD_URL = `${APP_ORIGIN}/#/reset-password`;

/** Hash route after successful Stripe Checkout (see `create-checkout` success_url). */
export const CHECKOUT_THANK_YOU_PATH = "/thank-you";
/**
 * Stripe replaces `{CHECKOUT_SESSION_ID}`. Query before `#`; hash `#/` then client
 * redirect to `#/thank-you` (`StripeCheckoutReturnHandler`).
 */
export const CHECKOUT_SUCCESS_URL = `${APP_ORIGIN}/?session_id={CHECKOUT_SESSION_ID}#/`;

/** Default Stripe Checkout cancel — Web Portal (match `create-checkout` fallback). */
export const CHECKOUT_CANCEL_URL = `${APP_ORIGIN}/#/webview`;

/** Explicit not-found page (hash route); same UI as unknown paths (`path="*"`). */
export const NOT_FOUND_PATH = "/404";
export const NOT_FOUND_URL = `${APP_ORIGIN}/#${NOT_FOUND_PATH}`;
